import store from '../../store/index'
export default {
    bind(el,binding) {
     
        if (store.state.user.roleName === '网销专员') {
          if (el.innerText == " 分配" || el.innerText == " 转移") {
            el.classList.add('is-disabled');
            el.disabled = true;
          }
        }
        if (store.state.user.roleName !== '系统管理员') {
          if (el.innerText == " 导入数据" || el.innerText == " 导出") {
            el.classList.add('is-disabled');
            el.disabled = true;
          }
        }
    },

}